import { QuestionBankStoreModel, QuestionBankUIModel } from '@examdojo/question-bank';
import { EntityState } from '@examdojo/state';

export enum AssignmentSectionType {
  Manual = 'manual',
  Adaptive = 'adaptive',
}

export interface AssignmentBuilderSectionStoreModel {
  id: string;
  type: AssignmentSectionType;
  questions: QuestionBankStoreModel[];
}

export interface AssignmentBuilderSectionUIModel extends Omit<AssignmentBuilderSectionStoreModel, 'questions'> {
  questions: QuestionBankUIModel[];
  totalMarks: number;
  questionCount: number;
}

export interface AssignmentBuilderProps {
  isDirty: boolean;
}

export interface AssignmentBuilderState
  extends EntityState<AssignmentBuilderSectionStoreModel, AssignmentBuilderProps> {}
